import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { UserService } from "src/app/services/user.service";
import { environment } from "src/environments/environment";
import { AppStorageService } from "src/app/services/app-storage.service";

// Capacitor
import { Browser } from "@capacitor/browser";

@Component({
  selector: "app-login",
  templateUrl: "./login.page.html",
  styleUrls: ["./login.page.scss"],
})
export class LoginPage implements OnInit {
  username: string;
  password: string;

  showResetPasswordForm: boolean;
  email: string;
  emailErrorMessage;

  constructor(
    private router: Router,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private userService: UserService,
    private appStorageService: AppStorageService
  ) {

  }

  async ngOnInit() {
    const userData = await this.appStorageService.get("userData");
    const accessToken = await this.appStorageService.get("accessToken");
    if (!userData && !!accessToken) {
      this.router.navigate(["/home"]);
      return;
    }
    this.username = "";
    this.password = "";
    this.email = "";
    this.showResetPasswordForm = false;
  }

  async login(keyCode?) {
    if (!!keyCode === false || keyCode === 13) {
      if (!!this.username === false && !!this.password === false) {
        // 'Tutti i campi sono richiesti'
        // 'Inserisci nome utente e password'
        return;
      }

      const loading = await this.loadingController.create({
        message: "Operazione in corso...",
      });
      await loading.present();

      const credentials = { name: this.username, password: this.password };

      const response = await this.userService.login(credentials);

      if (!!response === false || !!response.error) {
        await loading.dismiss();
        if (response.message === 'wrong-credentials') {
          return (await this.alertController.create({
            header: 'Accesso non riuscito!', // i18n ?
            message: 'Username o password sbagliati, controlla e riprova.', // i18n ?
            buttons: ['Riprova']
          })).present();
        } else {
          return (
            await this.alertController.create({
              header: "Accesso non riuscito!", // i18n ?
              message: "Ti preghiamo di riprovare più tardi.", // i18n ?
              buttons: ["Riprova"],
            })
          ).present();
        }
      }

      loading.dismiss();

      // Go to homepage
      const navRes = await this.router.navigate(['/home']);
    }
  }

  async loginAsGuest() {
    const loading = await this.loadingController.create({
      message: "Creazione del profilo Fantallenatore guest in corso...",
    });
    await loading.present();

    const response = await this.userService.loginAsGuest();

    loading.dismiss();

    if (!!response.error === false) {
      // Go to homepage
      await this.router.navigate(["/home"]);
    }
  }

  async register() {
    //this.ads.showInterstitial();
    await this.router.navigate(["/register"]);
    // const t = setTimeout(() => {
    //   this.facebookAudNetService.prepareInterstitial(true);
    //   clearTimeout(t);
    // }, 2000);
  }

  toggleResetPasswordForm() {
    this.showResetPasswordForm = !this.showResetPasswordForm;
  }

  async sendResetPasswordEmail(keyCode?) {
    if (!!keyCode === false || keyCode === 13) {
      this.emailErrorMessage = null;
      const validateResult = this.validateEmail();
      if (!!validateResult === false) {
        return;
      }

      // Validation passed. Do operation.
      const loading = await this.loadingController.create({
        message: "Operazione in corso...",
      });
      await loading.present();

      const response = await this.userService.resetPassword(this.email);

      if (!!response.error) {
        await loading.dismiss();

        let errorHeader = 'Errore sconosciuto!';
        let errorMessage = 'Qualcosa è andato storto con l\'operazione.';

        switch (response.message) {
          case "email-not-found":
            errorHeader = 'E-Mail non registrata';
            errorMessage = 'Non esiste nessun account associato a questa e-mail! Crea un nuovo account oppure inserisci l\'email corretta per recuperare la password.';
            break;
          default:
            // Leave defaults
            break;
        }

        return (await this.alertController.create({
          header: errorHeader,
          message: errorMessage,
          buttons: [
            { text: "Capito", role: "dismiss" },
          ],
        })).present();
      }

      // All was OK
      await loading.dismiss();

      (await this.alertController.create({
          header: "Controlla la tua email!",
          message: "Ti abbiamo inviato il link per reimpostare la password. Segui le istruzioni!",
          buttons: [
            { text: "Capito", role: "dismiss", handler: async () => {} },
          ],
        })
      ).present();
    }
  }

  validateEmail() {
    const expression = RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$");
    if (expression.test(this.email)) {
      return true;
    }
    this.emailErrorMessage = "Assicurati di inserire una email valida";
    return false;
  }

  async openPrivacyPolicyUrl() {
    await Browser.open({ url: environment.privacyPolicyUrl });
  }

  async openTermsAndConditionsUrl() {
    await Browser.open({ url: environment.termsAndConditionsUrl });
  }
}
